import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'sortByDate' })
export class SortByDatePipe implements PipeTransform {
  transform(array: any[], field: string = 'updatedAt'): any[] {
    if (!Array.isArray(array)) return [];
    return [...array].sort((a, b) => {
      const aDate = a[field] ? new Date(a[field]).getTime() : 0;
      const bDate = b[field] ? new Date(b[field]).getTime() : 0;
      return bDate - aDate;
    });
  }
}
